import { Checkbox, Tooltip } from '@mui/material';
import Input from '../../../../components/Inputs/Input';
import './PartsSelector.css';
import { Dropdowns } from '../../../../components/Dropdowns/Dropdowns';
import { useEffect, useState } from 'react';
import { getParts } from '../../services/PartsConfigurationService';
import { dropdownColumnMap, dropdownValueMap } from '../../../../redux/features/configuration/parts/partsConfigurationSlice';
import { ataFormatter } from '../../../../utils/utils';
import { DialogTrigger } from '../../../../components/Dialog/Dialog';
import { InterchangeabilitySummary } from './InterchangeabilitySummary';
import { environment } from '../../../../environments/environment';
import useDebounce from '../../../../hooks/useDebounce';

export const PartsSelector = ({ type, onClose, subCategory, onApplySelection, previousSelection, sourcePartId }) => {

    const [partOptions, setPartOptions] = useState([]);
    const [selection, setSelection] = useState(new Set([]));
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [conditionalNote, setConditionalNote] = useState('');
    const [search, setSearch] = useState("");
    const debouncedSearch = useDebounce(search, 300);

    // const onNewOptions = (newOptions) => {
    //     setPartOptions(newOptions);
    // }

    const loadParts = (requestedPage) => {
        getParts({ dropdowns: { 3: [{ id: subCategory }] }, txt: {} }, dropdownColumnMap, dropdownValueMap, requestedPage, environment.ElemensPerPage, "partNumber", search).then(response => {
            if (response.data.responseCode === 200) {
                let filteredLoad = response.data.load.filter(p => !previousSelection?.has(p.id))
                setPartOptions(prev => page === 0 ? filteredLoad : [...prev, ...filteredLoad]);
                setTotalPages(response.data.totalPages);
            }
        })
    }

    useEffect(() => {
        loadParts(page);
    }, [page, subCategory]);

    useEffect(() => {
        // loadParts(0);
        setPage(prev => {
            if (prev === 0) {
                loadParts(0)
            }
            return 0;
        })
    }, [debouncedSearch])

    const handleScroll = (event) => {
        const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
        if (scrollHeight - (scrollTop + 3) <= clientHeight) {

            setPage(prev => Math.min(prev + 1, totalPages));
        }
    }

    const handleCheck = (partId, select) => {
        const newSelection = new Set(selection);
        select ? newSelection.add(partId) : newSelection.delete(partId);
        setSelection(newSelection);
    }

    const isChecked = (part) => selection.has(part.id);

    const addClick = (e) => {
        onApplySelection(partOptions.filter(p => selection.has(p.id)), conditionalNote);
        onClose(e);
    }

    return (
        <div className='parts-selector-component'>
            <div className='header'>
                <div className='left'>
                    <i className={`icon-${type === "Both Ways" ? 'two-way' : 'one-way'}`}></i>
                    <span>{type}</span>
                </div>
                <div className='right'>
                    {/* <DialogTrigger dialogContent={{component: InterchangeabilitySummary, props:{sourcePartId, targetPartId: selection.values().next().value}}}> */}
                    <button disabled={!(selection.size > 0)} onClick={(e) => addClick(e)} className='filled iconTextButton small-size'>
                        <span>Add Selected</span>
                    </button>
                    {/* </DialogTrigger> */}
                    <button className='outlined icon small-size' onClick={onClose}>
                        <i className='icon-cross'></i>
                    </button>

                </div>
            </div>
            <div className='content'>
                {
                    partOptions.length > 0 ? <>


                        <div className='notes'>
                            <div className='label'>
                                <i className='icon-notes'></i>
                                <b>Conditional Notes</b>
                            </div>
                            <textarea onChange={(e) => setConditionalNote(e.target.value)} />
                        </div>
                        <Input placeholder="Search" onChange={e => setSearch(e.target.value)} />
                        <div className={`list ${totalPages > (page + 1) ? 'hasMorePages' : ''}`} onScroll={handleScroll}>
                            {partOptions.map(p => <div key={p.id} className={`part ${isChecked(p) ? 'selected' : ''}`} onClick={() => handleCheck(p.id, !isChecked(p))}>
                                <Checkbox checked={selection.has(p.id)} onChange={(e) => handleCheck(p.id, e.target.checked)} />
                                <b>{p.partNumber}</b>
                                {/* <span className='part-info'>{p.description}</span> */}
                                <Tooltip arrow title={p.description}>
                                    <span className='part-info'>{p.description}</span>
                                </Tooltip>
                                <span className='part-info'>{ataFormatter(p)}</span>
                                {/* <span>{}</span> */}
                            </div>)}
                        </div>
                        {/* {JSON.stringify(page)} */}
                    </>:
                    <div className='placeholder-component'>
                        <i>No parts available</i>
                        </div>
                }
            </div>


            {/* <input className='search'></input> */}
        </div>

    )
}